import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import {
  DateRow,
  Loader,
  PaginationItem, PriceConvertor, PriceRow,
  SearchAndFilter,
  TableNoInfo,
  TextRow, TypeRow,HyperLinkRow
} from 'components';
import { FindLoad, PermissionsList, RolePermission, SendPageSave, useGlobalStyles } from 'utils';
import { collectionActions } from 'store';
import { collectionHistoryHead } from './constants';

const ACTION_TYPE = 'GET_COLLECTION_HISTORY';
export const CollectionsHistory = ({}) => {
  const { collectionHistory } = useSelector((state) => ({
    collectionHistory: state.collections.collectionHistory,
  }));
  const dispatch = useDispatch();
  const history = useHistory();
  const info = history?.location?.state;
  const globalStyle = useGlobalStyles();
  const loader = FindLoad(ACTION_TYPE);
  const [expanded, setExpanded] = React.useState(null);

  useEffect(() => {
    dispatch(collectionActions.getCollectionHistory());
  }, [dispatch]);

  const handleChange = (id) => {
    if (id === expanded) {
      setExpanded(null);
    } else {
      setExpanded(id);
    }
  };

  return (
    <div className="collection-history-section">
      <div className={globalStyle.tableWrapper} style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        background: 'white',
      }}
      >
        <div>
          <div className="accordion-table-head-wrapper">
            {collectionHistoryHead?.map((i, j) => (
              <div className="accordion-table-head" key={j} style={{ width: i?.rowWidth }}>
                <SearchAndFilter item={i} />
              </div>
            ))}
          </div>

          {loader?.length ?
            <Loader />
            :
            <>
              <div className="accordion-table-body-scroll">
                {collectionHistory?.collections?.length ? collectionHistory?.collections?.map((i, j) => (
                    <React.Fragment key={j}>
                      <Accordion expanded={expanded === j} onChange={() => handleChange(j)} key={j}>
                        <AccordionSummary
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <div className="accordion-table-body-wrapper">
                            <div style={{ width: '12%' }} className="accordion-table-body">
                              <DateRow date={i?.createdDate} />
                            </div>
                            <div style={{ width: '15%' }} className="accordion-table-body">
                              <TextRow name={`${i?.creator?.firstName} ${i?.creator?.lastName}`} />
                            </div>
                            <div style={{ width: '15%' }} className="accordion-table-body">
                              <HyperLinkRow
                                // name={`${i?.carrier?.firstName} ${i?.carrier?.lastName}`}
                                name={i?.carrier?.companyName ? i?.carrier?.companyName  : 'N/A'}
                                href={RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) ? `/vendor/${i?.carrier?._id}` : ''}
                                checkPermission={i?.carrier?._id ? RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) : null}
                              />
                              {/*<TextRow name={`${i?.carrier?.firstName} ${i?.carrier?.lastName}`} />*/}
                            </div>
                            <div style={{ width: '15%' }} className="accordion-table-body">
                              <TypeRow text={i?.type} />
                            </div>
                            <div style={{ width: '20%' }} className="accordion-table-body">
                              <TypeRow text={i?.description} />
                            </div>
                            <div style={{ width: '20%' }} className="accordion-table-body">
                              <PriceRow info={i?.totalAmount || 0} />
                            </div>
                            <div style={{ width: '3%' }} className="accordion-table-body">
                              {j === expanded ?
                                <ExpandLessIcon />
                                :
                                <ExpandMoreIcon />
                              }
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>
                          {expanded === j &&
                            <div className="load-payroll-table">
                              <div className="load-payroll-box">
                                <p className="load-payroll-title">From</p>
                                {i?.fromLoads?.length ?
                                  i?.fromLoads?.map((i, j) => (
                                    <div key={j} className="load-payroll-row">
                                      <div className="load-payroll-item-box">
                                        <p className="load-payroll-item-title">Load ID:</p>
                                        <p className="load-payroll-item-value">{i?.displayId}</p>
                                      </div>
                                      <div className="load-payroll-item-box">
                                        <p className="load-payroll-item-title">Amount:</p>
                                        <p className="load-payroll-item-value"><PriceConvertor price={i?.amount} /></p>
                                      </div>
                                    </div>
                                  ))
                                  :
                                  <TableNoInfo text={`Not Yet`} />
                                }
                              </div>
                              <div className="load-payroll-box">
                                <p className="load-payroll-title">To</p>
                                {i?.toLoads?.length ?
                                  i?.toLoads?.map((i, j) => (
                                    <div key={j} className="load-payroll-row">
                                      <div className="load-payroll-item-box">
                                        <p className="load-payroll-item-title">Load ID:</p>
                                        <p className="load-payroll-item-value">{i?.displayId}</p>
                                      </div>
                                      <div className="load-payroll-item-box">
                                        <p className="load-payroll-item-title">Amount:</p>
                                        <p className="load-payroll-item-value"><PriceConvertor price={i?.amount} /></p>
                                      </div>
                                    </div>
                                  ))
                                  :
                                  <TableNoInfo text={`Not Yet`} />
                                }
                              </div>
                            </div>
                          }
                        </AccordionDetails>
                      </Accordion>
                    </React.Fragment>
                  )) :
                  <div style={{ height: '100px' }}>
                    <TableNoInfo text={`No Load Yet`} />
                  </div>
                }
              </div>
            </>
          }
        </div>

        {!!collectionHistory?.count > 0 &&
          <div style={{ background: 'white', border: '0 0 8px 8px' }}>
            <PaginationItem
              listInfo={collectionHistory?.collections}
              handleReturn={(number) => SendPageSave(number, info, history)}
              count={collectionHistory?.count}
              styles={{ margin: '0 0 21px 0' }}
            />
          </div>
        }
      </div>
    </div>
  );
};
